import * as React from "react";
import PageNavigation from "components/common/PageNavigation";
import { Row } from "components/bootstrap";
import { PAGE_NAV_TITLE } from "auditlog/bindings";
const AuditLogPageNavigation = () => /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAV_TITLE }));
export default AuditLogPageNavigation;
